<div *ngIf="!AccessAllowed && CompletedLoading">
    <h3 style="border: 2px solid;border-radius: 6px;position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);padding: 10px;">You don't have access to this function</h3>
</div>

<div *ngIf="AccessAllowed" class="p-3">

    <div style="margin-bottom: 12px; text-align: right;">
        <button pButton type="button" class="p-button-outlined p-button-sm" style="height: 34px;" (click)="goBack()">
            <span class="pi pi-chevron-left" style="margin-right: 6px;"></span>
            <span>Back to At a Glance</span>
        </button>
    </div>

    <div class="text-900 font-medium text-xl mb-3"><h3>New Customer Bookings
    </h3></div>
    <p class="m-0 mb-4 p-0 text-600 line-height-3 mr-3">
        <span class="pi pi-info-circle" style="margin-right:2px;"></span>
        This list shows all new bookings made by customers.  Please click the green thumbs up to clear this booking from the list, you can also view the booking by clicking on the eye button.  This does not have any effect on the booking it is just a way for you to see new bookings/check them if you wish and clear the list ready for the next bookings.
    </p>

    <div class="surface-card p-4 shadow-2 border-round">

        <div *ngIf="ListBookings == null || ListBookings.length == 0" style="width:100%">
            <p style="text-align:center; font-size:20px;">There are currently no bookings to acknowledge</p>
        </div>

        <p-table *ngIf="ListBookings && ListBookings.length > 0"
        [value]="ListBookings" sortField="startTime"
        responsiveLayout="scroll">
            <ng-template pTemplate="header">
                <tr>
                    <th style="padding: 7px;" width="1%">
                        &nbsp;
                    </th>
                    <th pSortableColumn="bookingId">Sales ID
                        <p-sortIcon [field]="bookingIdHR"></p-sortIcon>
                    </th>
                    <th style="text-align:center" pSortableColumn="startTime">Start Date/Time
                        <p-sortIcon [field]="startTime"></p-sortIcon>
                    </th>
                    <th pSortableColumn="name">Name
                        <p-sortIcon [field]="name"></p-sortIcon>
                    </th>
                    <th pSortableColumn="packageName">Package
                        <p-sortIcon [field]="packageName"></p-sortIcon>
                    </th>
                    <th pSortableColumn="guests">Guests
                        <p-sortIcon [field]="guests"></p-sortIcon>
                    </th>
                    <th style="text-align: center;" pSortableColumn="outstanding">Total<br>O/S
                        <p-sortIcon [field]="outstanding"></p-sortIcon>
                    </th>
                    <th style="padding: 3px;" width="1%"></th>
                    <th style="padding: 3px;" width="1%"></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-data>
                <tr [ngStyle]="{'background-color': (data.disabled==true) ? '#fee' : '#ffffff'}" *ngIf="!data.inProgress && !inProgress" onmouseover="this.originalstyle=this.style.backgroundColor;this.style.backgroundColor='#dddddd'" onmouseout="this.style.backgroundColor=this.originalstyle;" [ngStyle]="{'background-color': (data.disabled==true) ? '#fee' : '#ffffff'}">
                    <td style="padding: 7px;">
                        <div *ngIf="data.publicBooking" class="pi pi-user"></div>
                        <div *ngIf="data.extraslist != '' && data.extraslist != null" class="pi pi-star-fill"></div>
                        <div *ngIf="data.allergy != '' && data.allergy != null" class="pi pi-asterisk"></div>
                        <div style="color:red" *ngIf="data.notes != '' && data.notes != null" class="pi pi-exclamation-circle"></div>
                    </td>
                    <td>{{data.bookingIdHR}}</td>
                    <td style="text-align: center;">
                        <div>{{data.startTime | date:'dd/MM/yy'}}</div>
                        <div>{{data.startTime | date:'HH:mm' : 'UTC'}}</div>
                    </td>
                    <td>{{data.name}}</td>
                    <td>{{data.packageName}}</td>
                    <td>{{data.guests}}</td>

                    <td>
                        <div style="text-align: center;">{{data.total | currency: CurrencySymbol}}</div>
                        <div style="text-align: center;" *ngIf="data.outstanding <=0">
                            {{data.outstanding | currency: CurrencySymbol}}
                        </div>
                        <div style="text-align: center;" *ngIf="data.outstanding > 0">
                            <span style="color: Red; font-weight: bold;">{{data.outstanding | currency: CurrencySymbol}}</span>
                        </div>
                    </td>

                    <td style="padding: 3px;">
                        <button pButton type="button" pTooltip="View Booking" class="p-button-sm p-element p-ripple p-button-info p-button p-component" (click)="viewBooking(data.bookingId)">
                            <span class="pi pi-eye"></span>
                        </button>
                    </td>

                    <td style="padding: 3px;">
                        <button *ngIf="!data.acknowledged && data.disabled!=true" pButton type="button" pTooltip="Acknowledge" class="p-button-sm p-element p-ripple p-button-success p-button p-component" (click)="acknowledge(data.bookingId)">
                            <span class="pi pi-thumbs-up"></span>
                        </button>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>

</div>
